

















import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';

import { store } from '../store/edit';
import Pneu from './Pneu.vue';
import { MAX_POCET_PNEU, POLOZKA_PREFIX } from '../constants';

export default PageModeMixin.extend({
	name: 'PneuTable',
	components: { Pneu },
	props: {
		storeUri: { type: String, default: null, required: true },
		disabled: { type: Boolean },
	},
	data() {
		return {
			polozkaPrefix: POLOZKA_PREFIX,
		};
	},
	computed: {
		...genVuexComputeds(store),
		loading(): boolean {
			return this.polozky.loadingCount > 0;
		},
		count: {
			get(): number {
				return this.polozky.data.length;
			},
			set(newVal: number) {
				if (newVal > MAX_POCET_PNEU) return;
				const incress = newVal > this.polozky.data.length;
				if (incress) this.increaseWheel();
				else this.decreaseWheel();
			},
		},
		lg(): number[] {
			let rest = 24 % this.count;
			const lgSize = Math.trunc(24 / this.count);
			const lgs = [];
			for (let i = 0; i < this.count; i++) {
				lgs.push(lgSize + ((rest > 0) ? 1 : 0));
				rest -= 1;
			}
			return lgs;
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		...mapMutationsDvm(store.mutations),
	},
});
